/**
 * Update Settings Schema
 *
 * Zod validation schema for updating settings records
 */

import { z } from "zod";

/**
 * Delay schema for settings
 */
const delaySchema = z.object({
  id: z.number().nullable(),
  reason: z.string(),
  icon: z.string(),
  time: z.string()
});

/**
 * Schema for updating settings
 */
const updateSettingsArgsSchema = z.object({
  id: z.number(),
  programmedTotal: z.number(),
  timeAttendence: z.string(),
  start: z.string(),
  end: z.string(),
  startInterval: z.string(),
  endInterval: z.string(),
  googleMaps: z.string(),
  weekDays: z.string(),
  hour_entry_Limit: z.number(),
  queue_edit_hours_limit: z.number(),
  scheduling_day_limit: z.number(),
  enable_missing_validation: z.boolean(),
  missing_limit: z.number(),
  missing_limit_after_block: z.number(),
  missing_validation_period: z.number(),
  enableTolerance: z.boolean(),
  tolerance: z.string(),
  checkinIp: z.string(),
  enableRecaptcha: z.boolean(),
  recaptchaSecret: z.string().nullable(),
  enableQueueSave: z.boolean(),
  enableCheckin: z.boolean(),
  enableQueueWithoutScheduling: z.boolean(),
  company: z.number(),
  delay: z.array(delaySchema),
  hour_entry_limit_attended: z.number().nullable(),
  hour_entry_limit_missing: z.number().nullable()
});
